// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2h9c5","row":"styles_row__1hxM2"};